var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.94 22.16c-1.95 0-3.44-.71-4.2-1.99-.75-1.28-.65-2.93.3-4.63L8.1 4.63c1-1.8 2.38-2.79 3.9-2.79s2.9.99 3.9 2.79l6.06 10.91c.95 1.71 1.06 3.35.3 4.63-.76 1.28-2.25 1.99-4.2 1.99H5.94zm3.47-16.8L3.36 16.27c-.68 1.22-.79 2.34-.32 3.15.47.8 1.51 1.25 2.91 1.25h12.12c1.4 0 2.43-.44 2.91-1.25.47-.81.36-1.92-.32-3.15L14.59 5.36c-.73-1.3-1.65-2.02-2.59-2.02s-1.86.72-2.59 2.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.01 20.61 12 14.3l-9.01 6.31a.74.74 0 0 1-1.04-.18.74.74 0 0 1 .18-1.04l9.44-6.61c.26-.18.6-.18.86 0l9.44 6.61c.34.24.42.71.18 1.04-.14.21-.37.32-.61.32-.15 0-.3-.04-.43-.14z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13.39V3c0-.41.34-.75.75-.75s.75.34.75.75v10.39c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineTriangle);
export default __webpack_public_path__ + "static/media/vuesax-outline-triangle.077440abda8b750dd5c4c91815e53c8c.svg";
export { ForwardRef as ReactComponent };